import { error as logErrorToConsole } from '@ms/yammer-console-logging';
import { isNAAChannelRecommendedWithTelemetry } from '@ms/yammer-web-support/dist/metaOsHub';

type IsNAASupportAvailable = () => Promise<boolean>;
export const isNAASupportAvailable: IsNAASupportAvailable = async () => {
  try {
    const isNAAChannelRecommended = isNAAChannelRecommendedWithTelemetry();

    return isNAAChannelRecommended;
  } catch (error) {
    logErrorToConsole(`Error checking NAA support availability: ${String(error)}`);

    return false;
  }
};
